export const META_PIXEL_ID = "1683484609319506"
export const BOOK_ANCHOR_ID = "book"

export const CAL_30MIN_LINK = "team/hirealigned/hirealigned-30-minutes-call"
export const CAL_30MIN_NAMESPACE = "hirealigned-30-minutes-call"

export const CAL_DEMO_LINK = "team/hirealigned/hirealigned.com-demo-request"
export const CAL_DEMO_NAMESPACE = "hirealigned-com-demo-request"

// Nested routes that set their own `openGraph` drop the root opengraph-image,
// so each one names it explicitly.
export const DEFAULT_OG_IMAGE = "/opengraph-image"

export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL ?? "https://hirealigned.com"
